import { apiClient } from '../http/query-client';

export function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
}

export function saveFbclidFromUrl(): void {
  if (typeof window === 'undefined') return;
  try {
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get('fbclid');
    if (fbclid) {
      localStorage.setItem('sb_fbclid', fbclid);
    }
  } catch (e) {}
}

export function getFbc(): string | null {
  if (typeof window === 'undefined') return null;
  
  // 1. Native Meta Pixel cookie
  const cookieVal = getCookie('_fbc');
  if (cookieVal && cookieVal.startsWith('fb.')) {
    return cookieVal;
  }

  // 2. LocalStorage fallback if set previously
  const lsFbc = localStorage.getItem('_fbc');
  if (lsFbc && lsFbc.startsWith('fb.')) {
    return lsFbc;
  }

  // 3. Fallback to saved fbclid in localStorage (standard Meta format: fb.1.{timestamp_seconds}.{fbclid})
  const savedFbclid = localStorage.getItem('sb_fbclid');
  if (savedFbclid) {
    const unixSeconds = Math.floor(Date.now() / 1000);
    return `fb.1.${unixSeconds}.${savedFbclid}`;
  }

  return null;
}

export function getFbp(): string | null {
  if (typeof window === 'undefined') return null;

  // 1. Native Meta Pixel cookie
  const cookieVal = getCookie('_fbp');
  if (cookieVal && cookieVal.startsWith('fb.')) {
    return cookieVal;
  }

  // 2. LocalStorage fallback
  const lsFbp = localStorage.getItem('_fbp');
  if (lsFbp && lsFbp.startsWith('fb.')) {
    return lsFbp;
  }

  return null;
}

// Auto-capture fbclid upon module load in browser context
if (typeof window !== 'undefined') {
  saveFbclidFromUrl();
}

export function trackFacebookEvent(
  eventName: string,
  customData: Record<string, any> = {},
  userData: Record<string, any> = {}
) {
  const hasFbq = typeof window !== 'undefined' && (window as any).fbq;
  const eventId = eventName.toLowerCase() + '_' + Math.random().toString(36).substring(2, 15);

  const fbcVal = getFbc();
  const fbpVal = getFbp();

  const enrichedUserData = {
    ...userData,
  };
  if (fbcVal && !enrichedUserData.fbc) enrichedUserData.fbc = fbcVal;
  if (fbpVal && !enrichedUserData.fbp) enrichedUserData.fbp = fbpVal;

  // 1. Fire Browser Event (Meta Pixel)
  if (hasFbq) {
    (window as any).fbq('track', eventName, customData, { eventID: eventId });
  }

  // 2. Fire Server Event (Conversions API via our backend proxy)
  apiClient.post('facebook/event', {
    event_name: eventName,
    event_id: eventId,
    user_data: enrichedUserData,
    custom_data: customData,
    event_source_url: typeof window !== 'undefined' ? window.location.href : undefined,
  }).catch(() => {});
}
